import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './css/dracula.min.css';
import './css/style.css';
import './i18n';

import App from './app/App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
